// extracted by mini-css-extract-plugin
module.exports = {"button":"UpgradeButton_button__l49dd","spin360":"UpgradeButton_spin360__2pMdv"};